export default __webpack_public_path__ + "static/media/producao.45704f83.svg";